import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/shopcart/upload_d2c.png'
import _imports_1 from '@/assets/image/shopcart/un_upload_d2c.png'


const _withScopeId = n => (_pushScopeId("data-v-7df58e37"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-file-modal-content" }
const _hoisted_2 = { class: "upload-part" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "upload-part-img"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "upload-part-img"
}
const _hoisted_5 = { class: "upload-part-text" }
const _hoisted_6 = { class: "download-template" }
const _hoisted_7 = {
  target: "_blank",
  href: "https://static-s.theckb.com/BusinessMarket/Client/userCenter/テンプレート_仕入先.xlsx"
}
const _hoisted_8 = { class: "download-tip" }

import { ref } from 'vue';
import { t, lang } from '@/plugins/i18n'
import UploadFailTable from './UploadFailTable.vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { ElMessage } from 'element-plus';
import { useStore } from 'vuex';
import { request } from '@/config/request/interceptors';

export default /*#__PURE__*/_defineComponent({
  emits: ['updateSuccess'],
  setup(__props, { emit: emits }) {


const importVisible = ref(false)
const file = ref()
const fileUploadErrorList = ref([])
const importErrorVisible = ref(false)
const store = useStore()

const upload = (uploadFile: any) => {
  if (uploadFile.size > 20 * 1024 * 1024) {
    ElMessage.warning(t('文件大于20M,请重新上传'))
    return false
  }
  file.value = uploadFile
  importVisible.value = false
  validUpload()
  return false
}

const validUpload = () => {
  // const fd = new FormData()
  // fd.append('file', file.value)
  store.commit('status/loading', true)
  ElMessage.success(t('读取文件中，即将更新数据'))

  const info: any = {
    1: '存在多个一样ckb sku: {sku}',
    2: '{sku} 该ckb sku不存在',
    3: '客户sku过长',
    4: '商品规格过长'
  }
  // /order/shop/product/sku/importCustomSupplier
  request.order.shop.productSkuImportCustomSupplier({ file: file.value }).then(res => {
    console.log(res)
    store.commit('status/loading', false)
    emits('updateSuccess')
    if (res.data?.errorList?.length) {
      importErrorVisible.value = true
      fileUploadErrorList.value = res.data?.errorList?.map((v: any, i: any) => {
        console.log(v, info[v.errorType], t(info[v.errorType]))
        return {
          rowNumber: v.rowIndex,
          error: t(info[v.errorType], { sku: v.productSku ?? '' })
        }
      })
    } else {
      importVisible.value = false
      ElMessage.success(t('供应商信息更新成功'))
    }
    file.value = null
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (importVisible.value = true)),
      style: {"margin-left":"10px"}
    }, [
      _renderSlot(_ctx.$slots, "trigger")
    ]),
    _createVNode(CommonDialog, {
      visible: importVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((importVisible).value = $event)),
      width: 600,
      title: _unref(t)('导入'),
      className: "upload-file-modal",
      onCancel: _cache[2] || (_cache[2] = () => importVisible.value = false)
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_upload, {
            drag: "",
            action: "",
            "before-upload": upload,
            accept: ".xls,.xlsx"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (file.value)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                  : (_openBlock(), _createElementBlock("img", _hoisted_4)),
                _createElementVNode("div", _hoisted_5, _toDisplayString(!file.value ? _unref(t)('上传文件') : (file.value?.size / 1024 > 1024 ? (file.value?.size /
            1024 /
            1024).toFixed(2) + 'M'
            : (file.value?.size / 1024).toFixed(0) + 'KB')), 1)
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", _hoisted_7, _toDisplayString(_unref(t)('模板下载2')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, _toDisplayString(_unref(t)('注意事项')), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)('1.表格数据最多为1000行，超过请分多个表格导入')), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)('2.仅支持.xlsx、.xls文件，且小于20M')), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)('3.导入成功后将更改供应商信息')), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(UploadFailTable, {
      visible: importErrorVisible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((importErrorVisible).value = $event)),
      list: fileUploadErrorList.value
    }, null, 8, ["visible", "list"])
  ], 64))
}
}

})